<template>
  <section class="custom-chart">
    <vue-highcharts
      type="chart"
      ref="vchart"
      :options="options"
      :redrawOnUpdate="true"
      :oneToOneUpdate="false"
      :animateOnUpdate="true"
    />
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import VueHighcharts from 'vue3-highcharts'
export default {
  name: 'challenge-chart',
  components: {
    VueHighcharts,
  },
  props: {
    data: [Object, Array],
  },
  computed: {
    series() {
      let _data = []
      if (this.data) {
        this.data.forEach((element) => {
          if (element.progress) {
            _data.push(parseFloat(element.progress))
          } else {
            _data.push(0)
          }
        })
      }
      return _data
    },
    xAxis() {
      let _data = []
      if (this.data) {
        this.data.forEach((element) => {
          _data.push(element.week)
        })
      }
      return _data
    },
    options() {
      let _options = {
        chart: {
          type: 'line',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          categories: this.xAxis,
        },
        yAxis: {
          title: {
            text: '% progress',
          },
        },
        tooltip: {
          valueSuffix: '%',
          formatter: function () {
            return (
              'Progress on <b>' + this.key + '</b> was <b>' + this.y + '%</b>'
            )
          },
        },
        plotOptions: {},
        series: [
          {
            name: '',
            data: this.series,
            color: '#0d6efd',
            animation: false,
          },
        ],
      }
      return _options
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-chart {
  width: auto;
  height: auto;
  text-align: center;
  margin: 0 auto;
}
</style>
